module.exports = __webpack_public_path__ + "img/sound-on.926a7882.svg";